import Box from '@mui/material/Box';
import { FC, memo } from 'react';

import Paragraph from './Paragraph';

type TextProps = {
  texts: string[];
};

type ConditionalTextProps = TextProps & {
  withBox?: boolean;
};

const Text: FC<TextProps> = ({ texts }) => (
  <>
    {texts.map(text => (
      <Paragraph key={text}>{text}</Paragraph>
    ))}
  </>
);

const TextWithBox: FC<TextProps> = ({ texts }) => (
  <Box sx={{ marginTop: '1.5rem' }}>
    <Text texts={texts} />
  </Box>
);

const CardConditionalText: FC<ConditionalTextProps> = ({ texts, withBox }) => {
  return withBox ? <TextWithBox texts={texts} /> : <Text texts={texts} />;
};

export default memo(CardConditionalText);
